var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    {
      staticClass: "d-flex flex-column",
      attrs: { id: "verify-match-container" }
    },
    [
      _c(
        "div",
        {
          staticClass: "row pt-md-3 pt-2",
          attrs: { id: "verify-match-title-container" }
        },
        [
          _c(
            "div",
            { staticClass: "col-12 col-md-6 d-flex justify-content-center" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "custom-width ml-md-5 justify-content-between d-md-flex align-items-center"
                },
                [
                  _c("back-arrow", {
                    attrs: {
                      "body-modal": _vm.$t(
                        "verify.match.quit.dialog.description"
                      ),
                      confirm: true,
                      title: _vm.$t("verify.match.page.header.title"),
                      "title-modal": _vm.$t("verify.match.quit.dialog.title")
                    }
                  })
                ],
                1
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "row pt-md-5 pt-2",
          attrs: { id: "verify-match-sub-container" }
        },
        [
          _c(
            "div",
            {
              staticClass: "col-12 col-md-6 col-title",
              attrs: { id: "verify-match-sub-container-left" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "custom-width ml-md-5 d-flex align-items-center"
                },
                [
                  _c("h1", { staticClass: "page-title w-75" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.$t("verify.match.page.title"))
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "custom-width ml-md-5 mt-3" }, [
                _c("h1", { staticClass: "content" }, [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("verify.match.page.subtitle"))
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-12 col-md-6 d-flex justify-content-center justify-content-md-start",
              attrs: { id: "verify-match-sub-container-right" }
            },
            [
              _vm.currentStep === 1
                ? _c("verify-match-step1", {
                    attrs: {
                      imageInvalidState: _vm.imagesInvalidState,
                      "vehicle-files-saved": _vm.vehicleFiles
                    },
                    on: { updateSelectedPhotos: _vm.onVehicleFilesUpdated }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentStep === 2
                ? _c("verify-match-step2", {
                    attrs: {
                      identifier: _vm.identifier,
                      match: _vm.match,
                      needScrollInvalidFeedback: _vm.needScrollInvalidFeedback,
                      scannedIdentifier: _vm.scannedIdentifier
                    },
                    on: {
                      updateMatch: _vm.updateMatch,
                      updateNeedScroll: function($event) {
                        return _vm.updateNeedScroll()
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "footer-create-annonce" },
        [
          _c(
            "span",
            { staticClass: "fixed-bottom-100px span-step d-none d-md-block" },
            [
              _vm._v(
                _vm._s(
                  _vm.$t("register.Step") +
                    " " +
                    _vm.currentStep +
                    "/" +
                    _vm.maxStep
                )
              )
            ]
          ),
          _vm._v(" "),
          _c("b-progress", {
            staticClass: "custom-progress-bar-no-radius",
            attrs: {
              max: _vm.maxStep,
              value: _vm.currentStep,
              height: "1em",
              variant: "primary"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "row h-100" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-md-12 d-flex align-items-center mb-2 ml-2 mr-2 justify-content-around"
              },
              [
                _c(
                  "b-button",
                  {
                    ref: "btnPrevStep",
                    staticClass: "mr-1",
                    attrs: {
                      disabled: _vm.currentStep === 1,
                      variant: "secondary"
                    },
                    on: { click: _vm.prevStep }
                  },
                  [
                    _c("div", { staticClass: "pr-3 pl-3" }, [
                      _vm._v(
                        _vm._s(
                          _vm.currentStep > 1
                            ? _vm.$t("Previous")
                            : _vm.$t("Back")
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "span-step d-block d-md-none" }, [
                  _vm._v(_vm._s(_vm.currentStep + " / " + _vm.maxStep))
                ]),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    ref: "btnNextStep",
                    staticClass: "mr-1",
                    attrs: { variant: "primary" },
                    on: { click: _vm.nextStep }
                  },
                  [
                    !_vm.isLoading
                      ? _c("div", { staticClass: "pr-4 pl-4" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.currentStep === _vm.maxStep
                                  ? _vm.$t("Finish")
                                  : _vm.$t("Next")
                              ) +
                              "\n          "
                          )
                        ])
                      : _c("b-spinner", { staticClass: "button-spinner" })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("MatchDoneModal", {
        attrs: { "did-insist": _vm.didInsist },
        on: { onAddRIBClicked: _vm.goToUserProfile, onEndClicked: _vm.goBack }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58969bb8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58969bb8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/match/VerifyMatch.vue
// module id = 55PS
// module chunks = 0